export const UPDATE_GRID_VIEW = (state, action) => {
  const { activeViewId, columnState, filterState, gridId, sortState } = action.payload;
  return {
    ...state,
    [gridId]: {
      // If change includes one of these then update otherwise keep old state
      // 0 is a valid activeViewId so use nullish coalescing instead of OR operator
      activeViewId: activeViewId ?? state[gridId]?.activeViewId,
      sortState: sortState || state[gridId]?.sortState,
      columnState: columnState || state[gridId]?.columnState,
      filterState: filterState || state[gridId]?.filterState
    }
  };
};

export const CLEAR_GRIDS = () => ({});

export const test = '';
